import { render, staticRenderFns } from "./PaginationTest.vue?vue&type=template&id=98587c74&"
import script from "./PaginationTest.vue?vue&type=script&lang=js&"
export * from "./PaginationTest.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports